var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyleTwoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37303"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17417",
    fill: "#fff",
    stroke: "#185edf",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h36v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.5.5h35v27H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17416",
    fill: "#185edf",
    d: "M4.204 4h12v20h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17418",
    fill: "#3377f6",
    opacity: 0.5,
    d: "M20.204 4h12v20h-12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyleTwoBlue);
export default __webpack_public_path__ + "static/media/Syle_Two_blue.7bcdce7871064bc4997dbe83afd59354.svg";
export { ForwardRef as ReactComponent };